import dashboard from "@/modules/dashboard/locales/en-US.js"
import products from "@/modules/products/locales/en-US.js"
import apps from "@/modules/apps/locales/en-US.js"
import uiEditor from "@/modules/uiEditor/locales/en-US.js"
import auth from "@/modules/auth/locales/en-US.js"
import releases from "@/modules/releases/locales/en-US.js"
import templates from "@/modules/templates/locales/en-US.js"
import files from "@/modules/files/locales/en-US.js"
import core from "@/modules/core/locales/en-US.js"

export default {
	"en-US": {
		global: {
			errors: {
				general: "There was an unexpected error, please try again later."
			}
		},
		...dashboard,
		...products,
		...apps,
		...uiEditor,
		...auth,
		...releases,
		...files,
		...core,
		...templates,
		...files
	}
}
